import React, { useState, useEffect, useRef } from "react";
import { Card, Col, Row, Table, Typography, Button } from "antd";
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import useRequest from "../hooks/useRequest";
import Footer from "../components/layout/Footer";
import { ShowToast, Severty } from "../helper/toast";
import { useLocation, useNavigate } from "react-router-dom";

function ContentPage() {
  const { request } = useRequest();
  const { pathname } = useLocation();
  const { Title, Text } = Typography;
  const [contentData, setcontentData] = useState({});
  const [barData, setBarData] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pathName, setPathName] = useState("");

  const fetchData = () => {
    let pathArr = pathname.split("/");
    request({
      url: `common/get-content/privacy-policy`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        console.log('data.data', data.data.data[0]);
        setcontentData((prev) => ({ ...prev, ...data.data.data[0] }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  useEffect(() => {
    fetchData();
    let isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      setBarData(true);
    } else {
      setBarData(false);
    }
  }, []);

  function createMarkup() {
    return { __html: contentData.description };
  }

  return (

    <div className="withOutLoginPage">
      <div className="withOutLogininner">
        <>

          <div className="static-pages testimonialMain pb-3">
            <div className="container">
              {/* <div className="pageTitle fw-bold">{contentData.name}</div> */}
              <div
                className="subTitle fs-6 fw-medium text-muted mt-2"
                dangerouslySetInnerHTML={createMarkup()}
              />
            </div>
          </div>

        </>
      </div>
    </div>
  );
}

export default ContentPage;
